// contexts/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { checkAuthState, signOutService } from '../Service/AuthService';

// Create a context with a default value.
// This prevents the app from crashing if a component uses useAuth()
// outside of an AuthProvider.
const AuthContext = createContext({
  currentUser: null,
  logout: () => Promise.resolve({ success: false, error: 'AuthProvider not found' }),
  loading: true,
});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // onAuthStateChanged returns an unsubscribe function
    const unsubscribe = checkAuthState((user) => {
      console.log("Auth state changed:", user); // Add this for debugging
      setCurrentUser(user);
      setLoading(false);
    });

    // Cleanup the listener when the component unmounts
    return unsubscribe;
  }, []);

  const logout = async () => {
    const result = await signOutService();
    if (result.success) {
      setCurrentUser(null);
    }
    return result;
  };

  const value = {
    currentUser,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {/* We render children only after the initial auth check is complete */}
      {!loading && children}
    </AuthContext.Provider>
  );
};